import React from 'react';
import { PopupDirection } from 'lego-on-react';
import { QuestionLink } from '../QuestionLink/QuestionLink';
import { HintPopup } from '../HintPopup/HintPopup';

interface Props {
    directions?: PopupDirection[];
    hint: React.ReactNode;
}

export const Hint: React.FC<Props> = ({ directions, hint }) => {
    return (
        <HintPopup directions={directions} hint={hint}>
            <QuestionLink />
        </HintPopup>
    );
};
